import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boat',
      d: 'M-3.5,-1h0.5v0.5h-0.5zM3,-1h0.5v0.5h-0.5zM-3,-0.5h2v0.5h-2zM0,-0.5h3v0.5h-3zM-2.5,0h5.5v0.5h-5.5z',
    },
    {
      paint: 'dock',
      d: 'M-1.5,-2h1v0.5h-1zM0.5,-2h1v0.5h-1zM-3.5,-1.5h2v0.5h-2zM-1,-1.5h0.5v0.5h-0.5zM1.5,-1.5h2v0.5h-2zM-3,-1h2v0.5h-2zM-0.5,-1h3.5v0.5h-3.5zM-1,-0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-0.5,-6h0.5v4h-0.5zM-0.5,-2h1v0.5h-1zM1.5,-2h1v0.5h-1zM-1.5,-1.5h0.5v0.5h-0.5zM-0.5,-1.5h2v0.5h-2zM-1,-1h0.5v0.5h-0.5z',
    },
    { paint: 'wheat', d: 'M2.5,-2.5h0.5v0.5h-0.5z' },
    {
      paint: 'sail',
      d: 'M0,-5.5h0.5v0.5h-0.5zM0,-5h1v0.5h-1zM0,-4.5h1.5v0.5h-1.5zM0,-4h2v0.5h-2zM0,-3.5h2.5v1.5h-2.5z',
    },
  ],
  pixels: 93,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'boat',
      d: 'M-3.5,-1h0.5v0.5h-0.5zM3,-1h0.5v0.5h-0.5zM-3,-0.5h2v0.5h-2zM0,-0.5h3v0.5h-3zM-2.5,0h5.5v0.5h-5.5z',
    },
    {
      paint: 'dock',
      d: 'M-1.5,-2h1v0.5h-1zM0.5,-2h1v0.5h-1zM-3.5,-1.5h2v0.5h-2zM-1,-1.5h0.5v0.5h-0.5zM1.5,-1.5h2v0.5h-2zM-3,-1h2v0.5h-2zM-0.5,-1h3.5v0.5h-3.5zM-1,-0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-0.5,-6.5h0.5v4.5h-0.5zM-0.5,-2h1v0.5h-1zM1.5,-2h1v0.5h-1zM-1.5,-1.5h0.5v0.5h-0.5zM-0.5,-1.5h2v0.5h-2zM-1,-1h0.5v0.5h-0.5z',
    },
    { paint: 'wheat', d: 'M2.5,-2.5h0.5v0.5h-0.5z' },
    {
      paint: 'sail',
      d: 'M0,-6h0.5v0.5h-0.5zM-1,-5.5h0.5v0.5h-0.5zM0,-5.5h1v0.5h-1zM-1.5,-5h1v0.5h-1zM0,-5h1.5v0.5h-1.5zM-2,-4.5h1.5v1h-1.5zM0,-4.5h2v0.5h-2zM0,-4h2.5v2h-2.5zM-2.5,-3.5h2v1.5h-2z',
    },
  ],
  pixels: 120,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'boat',
      d: 'M-3.5,-1h0.5v0.5h-0.5zM3,-1h0.5v0.5h-0.5zM-3,-0.5h2v0.5h-2zM0,-0.5h3v0.5h-3zM-2.5,0h5.5v0.5h-5.5z',
    },
    {
      paint: 'dock',
      d: 'M-0.5,-2h2v0.5h-2zM-3.5,-1.5h2v0.5h-2zM-1,-1.5h1v0.5h-1zM1.5,-1.5h2v0.5h-2zM-3,-1h2v0.5h-2zM-0.5,-1h3.5v0.5h-3.5zM-1,-0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M3,-4h1v0.5h-1zM2.5,-3.5h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM3.5,-3h1v1h-1zM1.5,-2.5h0.5v1h-0.5zM4,-2h0.5v0.5h-0.5zM0,-1.5h1.5v0.5h-1.5zM-1,-1h0.5v0.5h-0.5z',
    },
    { paint: 'waterLight', d: 'M3.5,-3.5h0.5v0.5h-0.5zM4,-1.5h0.5v0.5h-0.5z' },
    { paint: 'buoy', d: 'M-1.5,-2.5h1v0.5h-1zM-2,-2h1.5v0.5h-1.5zM-1.5,-1.5h0.5v0.5h-0.5z' },
  ],
  pixels: 73,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
